import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Badge,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const drawerWidth = 240;

// Créez un style personnalisé pour les éléments sélectionnés
const StyledListItem = styled(ListItem)(({ theme, selected }) => ({
  borderRadius: selected ? "0 30px 30px 0" : "0",
  backgroundColor: selected ? "#9c27b0" : "transparent", // Violet pour l'élément sélectionné
  color: selected ? "#fff" : theme.palette.text.primary,
  cursor: "pointer", // Curseur en forme de main pour indiquer que c'est cliquable
  "&:hover": {
    backgroundColor: selected ? "#9c27b0" : "#e0e0e0", // Gris plus foncé au survol si non sélectionné
    borderRadius: "0 30px 30px 0", // Arrondi uniquement au survol
  },
  "& .MuiListItemIcon-root": {
    color: selected ? "#fff" : theme.palette.text.primary,
    borderRadius: "0 30px 30px 0",
  },
}));

const Sidebar = ({ onClickItem }) => {
  const [selectedItem, setSelectedItem] = useState("dashboard");

  const handleClick = (component) => {
    setSelectedItem(component);
    onClickItem(component);
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#f8f9fa",
          boxShadow: "none",
          borderRight: "none",
        },
      }}
    >
      <Toolbar>
        <Typography variant="h6" noWrap component="div">
          Medclick
        </Typography>
      </Toolbar>

      <List>
        <StyledListItem
          button
          selected={selectedItem === "dashboard"}
          onClick={() => handleClick("dashboard")}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </StyledListItem>

        <StyledListItem
          button
          selected={selectedItem === "user"}
          onClick={() => handleClick("user")}
        >
          <ListItemIcon>
            <AnalyticsIcon />
          </ListItemIcon>
          <ListItemText primary="Utilisateurs" />
        </StyledListItem>

        <StyledListItem
          button
          selected={selectedItem === "nomenclature"}
          onClick={() => handleClick("nomenclature")}
        >
          <ListItemIcon>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText primary="Nomenclature" />
        </StyledListItem>

        <StyledListItem
          button
          selected={selectedItem === "marketing"}
          onClick={() => handleClick("marketing")}
        >
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText primary="Marketing" />
        </StyledListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar;
